"use client";
import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";

import { CloseIcon } from "@/components/icons/Close";
import { useState } from "react";
import { PDPProduct } from "../../page";
import SizeSelectorDropdown from "../SizeSelector/SizeSelector";
import styles from "./find-in-store.module.css";
const ClientComponent = ({
  sizes,
  product,
}: {
  sizes: any;
  product: PDPProduct;
}) => {
  const [selectedSize, setSelectedSize] = useState<any | undefined>(
    sizes.find((s: any) => s.isSelected)
  );

  const hasSelectedSize = Boolean(selectedSize);
  const activeWarehouses = hasSelectedSize
    ? selectedSize.warehouses?.filter((w: any) => w.store)
    : sizes
        .flatMap((s: any) => s.warehouses)
        .filter(
          (w: any, i: number, arr: any[]) =>
            w.store &&
            arr.findIndex((w2) => w2.store?.name === w.store?.name) === i
        );
  const enhancedSizes = {
    sizes: sizes.map((s: any) => ({
      ...s,
      isSelected: selectedSize?.itemId === s.itemId,
      selectSize: () => setSelectedSize(s),
    })),
    selectedSize,
  };
  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <span className={clsx(styles.trigger)}>Find in store</span>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content
          className={clsx("dialog-content", styles["content-modal"])}
          style={{ padding: "0" }}
        >
          {" "}
          <section className={styles.modal__inline}>
            <Dialog.Close className={styles.close}>
              <CloseIcon />
            </Dialog.Close>
            <Dialog.Title asChild>
              <p className={styles.modal__title}>Availability in store</p>
            </Dialog.Title>
          </section>
          <div className={styles.warehouses}>
            {activeWarehouses.map((warehouse: any) => (
              <div
                key={warehouse.store.name}
                className={styles.warehouseContainer}
              >
                <div className={styles.storeHeader}>
                  <h2 className={styles.storeName}>{warehouse.store.name}</h2>

                  {hasSelectedSize && (
                    <span
                      className={clsx(styles.stockStatus, {
                        [styles.inStock]: warehouse.stock === "In stock",
                        [styles.lowStock]:
                          warehouse.stock ===
                          "Low in stock, please call the store.",
                        [styles.outOfStock]: warehouse.stock === "Out of stock",
                      })}
                    >
                      {warehouse.stock}
                    </span>
                  )}
                </div>

                <p className={styles.storeAddress}>{warehouse.store.address}</p>

                <div className={styles.storeHours}>
                  {warehouse.store.openingHours
                    .split("\n")
                    .map((line: string, index: number) => (
                      <p key={index}>{line}</p>
                    ))}
                </div>

                <a
                  href={`mailto:${warehouse.store.email}`}
                  className={styles.contactLink}
                >
                  Contact store
                </a>
              </div>
            ))}
          </div>
          <div className={styles.sizeSelectorSticky}>
            <SizeSelectorDropdown
              sizes={enhancedSizes}
              comingSoon={false}
              product={product}
              showSizeGuide={false}
              position="top"
              showStockStatus={false}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ClientComponent;
